import { Component, input, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { toSignal } from '@angular/core/rxjs-interop';
import { GetPowerAnalysisResponse } from '../../../../core/services/dashboard.service';
import { OmniMqttService } from '../../../../core/mqtt/omni-mqtt.service';
import { DeviceTable } from '../../../../core/mqtt/omni-protocol.interface';

@Component({
    selector: 'app-contract-capacity',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './contract-capacity.component.html',
})
export class ContractCapacityComponent {
    private mqttService = inject(OmniMqttService);

    /** API 資料：僅用於取得契約容量值 */
    data = input<GetPowerAnalysisResponse['contractCapacity']>();

    /** MQTT DeviceTable Signal（每次 MQTT 更新會自動推播） */
    private deviceTable = toSignal(this.mqttService.deviceTable$, { initialValue: {} as DeviceTable });

    /** MQTT：VIRTUAL_1 的 Demand_15m（目前負載 kW） */
    currentLoadKw = computed(() => {
        const table = this.deviceTable();
        return (table['VIRTUAL_1']?.data?.['Demand_15m']?.value as number) ?? 0;
    });

    /** MQTT：Demand_15m 的採樣時間戳（毫秒，可直接傳給 date pipe） */
    sampledAt = computed(() => {
        const table = this.deviceTable();
        return (table['VIRTUAL_1']?.data?.['Demand_15m']?.timestamp as number) ?? null;
    });

    /** 前端計算使用率：Demand_15m / contractCapacityValue * 100，四捨五入至整數 */
    ratio = computed(() => {
        const capacity = this.data()?.contractCapacityValue;
        if (!capacity) return 0;
        return Math.round((this.currentLoadKw() / capacity) * 100);
    });

    isWarning = computed(() => this.ratio() >= 90);
}
